<template>
    <div>
        <header role="banner" class="topbar">
            <div class="columns is-mobile">
                <div class="column text-center">
                    <a class="logo">
                        <icon name="kollecto"></icon>
                        <span>Kollecto</span>
                    </a>
                </div>
                <div class="text-center language">
                    <div @click="setShowLanguageMenu()" v-for="(language, index) in languages" :key="index">
                        <icon v-show="language.selected" class="small-svg" :name="language.flag"></icon>
                        <span v-show="language.selected">{{language.shorten | toUpperCase}}</span>
                        <icon v-show="language.selected" class="small-svg fill-white" name="arrow-down"></icon>
                    </div>
                </div>
            </div>
        </header>
        <div v-show="showLanguageMenu" class="choose-language">
            <ul>
                <li @click="setSelectedLanguage(language), changeLocale(language.shorten)" v-for="(language, index) in languages" :key="index" :class="{'selected-language': language.selected}">
                    <icon class="small-svg" :name="language.flag"></icon>
                    <span>{{language.text}} ({{language.shorten | toUpperCase}})</span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "topbar",
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      showLanguageMenu: "getShowLanguageMenu",
      languages: "getLanguages",
      selectedLanguage: "getSelectedLanguage"
    })
  },
  methods: {
    ...mapActions({
      setSelectedLanguage: "setSelectedLanguage",
      setShowLanguageMenu: "setShowLanguageMenu"
    }),
    changeLocale(loc) {
      this.$i18n.locale = loc;
    }
  },
  created() {
    this.setSelectedLanguage(this.languages[0]);
  }
};
</script>

<style lang="scss" scoped>
.logo svg {
  width: 24px;
  /* color: #fff; */
  fill: #fff;
  position: relative;
  top: 4px;
  padding-right: 3px;
}

.language {
  position: absolute;
  top: 22px;
  right: 30px;
  color: #fff;

  & span {
    vertical-align: 4px;
    padding-left: 5px;
  }
}

.choose-language {
  position: absolute;
  top: 64px;
  width: auto;
  background-color: #2c3e50;
  color: #fff;
  right: 0;
  z-index: 9999;

  & ul li {
    padding: 10px 20px;

    &.selected-language {
      background-color: #596275;
    }

    & span {
      vertical-align: 3px;
      padding-left: 10px;
    }
  }
}
</style>
